import { render, staticRenderFns } from "./Trueplay.vue?vue&type=template&id=2804c411&scoped=true&"
import script from "./Trueplay.vue?vue&type=script&lang=js&"
export * from "./Trueplay.vue?vue&type=script&lang=js&"
import style0 from "./Trueplay.vue?vue&type=style&index=0&id=2804c411&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2804c411",
  null
  
)

export default component.exports